module.exports = __webpack_public_path__ + "static/media/26.259c79ee.jpg";